<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/vertical-solutions']">
    <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>COMMONS.KEY_GENERATION</span>
</div>


<tb-header specificTitle="COMMONS.KEY_GENERATION_APIREST"></tb-header>
<div class="contentGlobal">
  <mat-card class="vertical-solution-card" style="text-align: center">
    <mat-card-header>
      <mat-card-title><span translate>COMMONS.KEY_GENERATION</span></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="text-left" [innerHtml]="this.keyGenerationIntroduction"></div>
    </mat-card-content>
    <mat-card-actions>
      <div  style="margin-top: 1.5rem" >
        <button mat-flat-button color="primary" (click)="generateSolutionKey()">
          <span translate>COMMONS.GENERATE_KEY</span>
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>

